/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import QuotationUpload from "../QuotationUpload/QuotationUpload";

class UploadTemplate extends Component {
  state = {};

  _resetFileDetails = () => {
    this.props.setErrMsg("");
    this.props.setDocUri(null);
  };

  _uploadDocument = () => {
    const { selectedCategoryID, docURI } = this.state;
    if (selectedCategoryID !== null) {
      return (
        <QuotationUpload
          uploaded={docURI !== null}
          setDoc={this.props.setDoc}
          resetFileDetails={this._resetFileDetails}
        />
      );
    }
    return null;
  };

  render() {
    return (
      <div className="createdoc-upload-wrapper choose-template-wrapper">
        <div className="go-backto-tem-selection-row">
          <div
            id="get-back-to-templates"
            className="get-back-to-templates"
            onClick={() => this.props.setView(true)}>
            <span>
              <FontAwesomeIcon icon={["far", "arrow-left"]} />
            </span>
            &nbsp; Get back to templates
          </div>
          <div
            data-test="uploadtemplate-create-blank-document-button"
            id="create-blank-document"
            onClick={() => this.props.createDoc()}
            className="get-back-to-templates">
            Create blank document
          </div>
        </div>
        <div className="assetcreatedoc-popup-body">
          <div className="select-template-list-wrapper">
            {this._uploadDocument()}
          </div>
        </div>
      </div>
    );
  }
}

export default UploadTemplate;



// WEBPACK FOOTER //
// ./src/components/CreateDocPopup/UploadTemplate.js